import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContextProvider';
import { useIpAllowList } from 'contexts/IpAllowListContextProvider';
import { useNetworkCheck } from 'contexts/NetworkContextProvider';

export const ProtectedRoute = () => {
  const { token } = useAuth();
  const location = useLocation();
  const { isOnline } = useNetworkCheck();
  const { isCheckingIpAccess, isIpAccessAllowed } = useIpAllowList();

  if (isOnline && (isCheckingIpAccess || !isIpAccessAllowed)) {
    return <Navigate to="/login" replace />;
  }

  if (!token) {
    const redirectPath = `${location.pathname}${location.search}${location.hash}`;
    const searchParams = new URLSearchParams({ redirect: redirectPath });

    return <Navigate to={`/login?${searchParams.toString()}`} state={{ from: location }} replace />;
  }

  return <Outlet />;
};
